module.exports = __webpack_public_path__ + "img/Airlink.b6f78405.png";